import { formatPeriodLabel } from "./dateRange";

// Normaliza la respuesta cruda de `getSalesCharts` al shape que consumen los
// componentes de chart del header de Ventas (stacked + líneas) y el tab KPIs.
// El backend devuelve cada bucket como `{ period: ISO, total_amount|count|amount }`.
// Acá derivamos arrays paralelos alineados a `monthHeaders`, así los charts
// reciben data lista sin repetir el zipping.
//
// Centralizado porque lo usan dos módulos (salesReport y kpisReport) con el
// mismo contrato — cambiar el shape en un solo lugar.
export function normalizeSalesCharts(data, filterPeriod) {
    const {
        by_client: byClientRaw = [],
        client_counts: clientCountsRaw = [],
        avg_tickets: avgTicketsRaw = [],
        has_otros: hasOtros,
        top_n: topN,
        period_range: periodRange,
    } = data;

    // Headers del primer serie disponible; si by_client está vacío caemos a
    // client_counts o a un array vacío.
    const sourcePeriods = (byClientRaw[0]?.values
        || clientCountsRaw
        || []).map((entry) => entry.period);
    const monthHeaders = sourcePeriods.map(
        (iso) => formatPeriodLabel(iso, filterPeriod)
    );

    const byClient = byClientRaw.map((series) => ({
        name: series.name,
        values: series.values.map((entry) => Number(entry.total_amount || 0)),
    }));
    const clientCounts = clientCountsRaw.map((entry) => Number(entry.count || 0));
    const avgTickets = avgTicketsRaw.map((entry) => Number(entry.amount || 0));

    return Object.freeze({
        monthHeaders: Object.freeze(monthHeaders),
        byClient: Object.freeze(byClient.map(Object.freeze)),
        clientCounts: Object.freeze(clientCounts),
        avgTickets: Object.freeze(avgTickets),
        hasOtros: Boolean(hasOtros),
        topN: Number(topN || 0),
        periodRange: Object.freeze(periodRange || {}),
    });
}
